(function() {
  const modal = document.getElementById('sdx-qam');
  if (!modal) return;

  const addedSlot = modal.querySelector('[data-sdx-qam-added]');
  const suggestBox = modal.querySelector('[data-sdx-qam-suggest]');
  const suggestRail = modal.querySelector('[data-sdx-qam-rail]');
  let lastFocus = null;

  function openModal(productData, crossSellHTML) {
    lastFocus = document.activeElement;
    if (productData) {
      addedSlot.innerHTML = `
        <div class="sdx-qam__added-item">
          ${productData.image ? `<img src="${productData.image}" alt="${escapeHtml(productData.title)}" loading="lazy" width="56" height="56">` : ''}
          <div class="sdx-qam__added-info">
            <span class="sdx-qam__added-name">${escapeHtml(productData.title || '')}</span>
            <span class="sdx-qam__added-meta">${productData.quantity || 1} adet · ${escapeHtml(productData.price || '')}</span>
          </div>
        </div>
      `;
    }
    if (crossSellHTML && crossSellHTML.trim() !== '') {
      suggestRail.innerHTML = crossSellHTML;
      suggestBox.removeAttribute('hidden');
    } else {
      suggestBox.setAttribute('hidden', '');
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modal.querySelector('[data-sdx-qam-close]').focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  modal.querySelectorAll('[data-sdx-qam-close]').forEach(el => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  function escapeHtml(s) {
    if (!s) return '';
    return String(s).replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' TL';
  }

  // Build cross-sell HTML from the PDP cross-sell rail already on the page (if present).
  function buildCrossSellHTML() {
    let html = '';
    const xsCards = document.querySelectorAll('[data-sdx-quick-xs] .sdx-quick-xs__card');
    xsCards.forEach(card => {
      const link = card.querySelector('a[href]');
      const href = link ? link.getAttribute('href') : null;
      const img = card.querySelector('img');
      const name = card.querySelector('.sdx-quick-xs__name');
      const price = card.querySelector('.sdx-quick-xs__price');
      if (href) {
        html += `
          <a class="sdx-qam__card" href="${href}">
            ${img ? `<div class="sdx-qam__card-thumb"><img src="${img.src}" alt="" loading="lazy"></div>` : ''}
            <div class="sdx-qam__card-info">
              <span class="sdx-qam__card-name">${escapeHtml(name ? name.textContent : '')}</span>
              <span class="sdx-qam__card-price">${escapeHtml(price ? price.textContent : '')}</span>
            </div>
          </a>`;
      }
    });
    return html;
  }

  // Presentation-only: react to the single cart-add authority (sdx-cart.js → `cart:added`).
  // This module no longer POSTs to /cart/add itself — that prevented the double-add
  // (two global submit handlers firing on the same form).
  document.addEventListener('cart:added', function (e) {
    const detail = e.detail || {};
    const added = detail.added;
    if (!added) return;
    // /cart/add.js returns the single line item, or { items: [...] } for multi-add.
    const item = (added.items && added.items.length) ? added.items[added.items.length - 1] : added;
    if (!item || !item.id) return;

    openModal({
      title: item.product_title || item.title,
      image: (item.featured_image && item.featured_image.url) ? item.featured_image.url : item.image,
      quantity: item.quantity,
      price: formatMoney(item.final_price != null ? item.final_price : item.price)
    }, buildCrossSellHTML());
  });
})();
